import { jerseyCityConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function JerseyCityPage() {
  return <CityPageTemplate config={jerseyCityConfig} />;
}